import React, { useEffect, useState, useRef } from 'react';

import BannerCardA from './BannerCardA';
import BannerCardB from './BannerCardB';
import { getIsPadWidth } from '@elem/utils/devices';

import styles from './index.module.scss';

export default function Comp() {
    const isMobile = getIsPadWidth();
    const [scrollTop, setScrollTop] = useState(0);
    const regionTimer: any = useRef(null);

    useEffect(() => {
        const container = '.banner-container';
        const scrollHeight = !isMobile ? innerHeight - 46 : innerHeight - 46;
        AniContainer.create({
            asyncFromTo: [
                ['.banner-container .banner-card-b', { top: scrollHeight }, { top: 0 }, 0.001], // box1 视频秒现
            ],
            asyncTimeLine: [0.001],
            triggerElement: container,
            triggerHook: 1,
            offset: '0%',
            duration: '120%',
        });

        regionTimer.current = setTimeout(() => {
            const regionPopupEl = document.querySelector('.regionPopup') as HTMLElement;
            const gloBarTopEl = document.querySelector('.glo-bar-top') as HTMLElement;
            let finalHeight = 0;
            if (!!regionPopupEl) {
                const { height: eleHeight } = regionPopupEl.getBoundingClientRect();
                finalHeight += eleHeight;
            }
            if (!!gloBarTopEl) {
                const { height: barHeight } = gloBarTopEl.getBoundingClientRect();
                finalHeight += barHeight;
            }

            if (finalHeight > 0) {
                setScrollTop(finalHeight);
            }
        }, 1000);

        return () => {
            regionTimer.current = null;
            setScrollTop(0);
        };
    }, []);

    return (
        <div className={`${styles.comp} banner-container`}>
            <div className="sticky" style={{ top: scrollTop + 52 }}>
                <BannerCardA />
                <BannerCardB />
            </div>
        </div>
    );
}
